import { apiRequest } from "../util/apiUtils";

export const communicationList = async (params) => {
  try {
    const res = await apiRequest("get", `communication/list`, {
      queries: params,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const communicationDelete = async (payload) => {
  try {
    const res = await apiRequest("delete", `communication/delete`, {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const communicationStatusChange = async (payload) => {
  try {
    const res = await apiRequest("patch", `communication/status`, {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const notificationList = async (params) => {
  try {
    const res = await apiRequest("get", `notification/backend/list`, {
      queries: params,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};
export const backendSeen = async (payload) => {
  try {
    const res = await apiRequest("post", `notification/backend/seen`, {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    return err;
  }
};
